import {
	TabInstance,
	TabInstancesCookie,
	getTabInstancesCookie,
	setTabInstancesCookie,
} from './storage';

export function registerActiveTab(id: string): void {
	const state = getTabInstancesCookie();
	let newState = { activeTabId: id } as TabInstancesCookie;
	let newTabInstances = [] as TabInstance[];
	const newTab = { id, registeredAt: Date.now() } as TabInstance;

	if (state.tabInstances) {
		const tab = state.tabInstances.find((tabInstance) => {
			return tabInstance.id === id;
		});

		if (tab) {
			const tabInstances = state.tabInstances.filter(
				(tabInstance) => tabInstance.id !== id
			);
			newTabInstances = [...tabInstances, newTab];
		} else {
			newTabInstances = [...state.tabInstances, newTab];
		}
	} else {
		newTabInstances = [newTab];
	}

	newState = {
		...state,
		activeTabId: id,
		tabInstances: newTabInstances,
	};

	setTabInstancesCookie(newState);
}

export function unregisterTab(id: string): void {
	const state = getTabInstancesCookie();

	if (!state.tabInstances) {
		return;
	}

	const newInstances = state.tabInstances.filter(
		(instance) => instance.id !== id
	);

	let newActiveTabId = state.activeTabId;

	if (id === state.activeTabId) {
		const successors = newInstances.sort((a, b) => {
			return b.registeredAt - a.registeredAt;
		});

		if (successors && successors.length) {
			// TODO: What should happen if there are no successors?
			newActiveTabId = successors[0].id;
		}
	}

	const newState = {
		...state,
		activeTabId: newActiveTabId,
		tabInstances: newInstances.map((instance) => {
			if (instance.id === newActiveTabId) {
				return {
					...instance,
					registeredAt: Date.now(),
				};
			}
			return instance;
		}),
	} as TabInstancesCookie;

	setTabInstancesCookie(newState);
}

export function isActiveTab(id: string): boolean {
	const session = getTabInstancesCookie();
	return session.activeTabId === id;
}
